// extracted by mini-css-extract-plugin
export default {"usersPageWrapper":"UsersList_usersPageWrapper__eUZ3-"};